<div class="container-fluid vh-100 d-flex align-items-center justify-content-center">
  <div class="row w-100 overflow-hidden">
    <!-- Left Side: Sign In Form -->
    <div class="col-12 col-md-6 bg-white left-side">
      <div class="">
        <div class="mb-4">
          <img src=" assets/icons/icon.svg" alt="logo" class="img-icon" />
        </div>
        <h1 class="mb-4 text-center">Account Verification</h1>
        <h6 class="mb-3 text-center">Enter Verification code</h6>
      </div>
      <form class="form" (ngSubmit)="onSubmit()" #otpForm="ngForm">
        <div class="mx-auto otp-input-wrapper mb-4">
          <div class="otp-input-container d-flex justify-content-center gap-2">
            <input
              type="text"
              maxlength="1"
              class="otp-box"
              [(ngModel)]="otp[0]"
              name="otp0"
              required
              (input)="onOtpInput($event, 0)"
              (keydown)="onOtpKeyDown($event, 0)"
              autocomplete="one-time-code"
            />
            <input
              type="text"
              maxlength="1"
              class="otp-box"
              [(ngModel)]="otp[1]"
              name="otp1"
              required
              (input)="onOtpInput($event, 1)"
              (keydown)="onOtpKeyDown($event, 1)"
              autocomplete="one-time-code"
            />
            <input
              type="text"
              maxlength="1"
              class="otp-box"
              [(ngModel)]="otp[2]"
              name="otp2"
              required
              (input)="onOtpInput($event, 2)"
              (keydown)="onOtpKeyDown($event, 2)"
              autocomplete="one-time-code"
            />
            <input
              type="text"
              maxlength="1"
              class="otp-box"
              [(ngModel)]="otp[3]"
              name="otp3"
              required
              (input)="onOtpInput($event, 3)"
              (keydown)="onOtpKeyDown($event, 3)"
              autocomplete="one-time-code"
            />
          </div>

          <p class="mb-3 text-center text-muted">
            Enter four digit verification code sent on your email id
            <span class="fw-bold">{{ email | maskEmail }}</span>
          </p>
        </div>
        <div class="text-center">
          <button type="submit" class="btn-submit p-2 w-75 fw-bold">Sign In</button>
        </div>
      </form>
      <div class="text-center mt-3">
        <button
          type="button"
          class="btn btn-link btn-resend"
          (click)="resendOtp()"
          [disabled]="resendTimeLeft > 0"
        >
          Resend
          <span *ngIf="resendTimeLeft > 0"> in {{ resendTimeLeft }} seconds </span>
        </button>
      </div>
    </div>

    <!-- Right Side: Welcome Section -->
    <div class="col-12 col-md-6 d-none d-md-flex align-items-center justify-content-center p-0">
      <img src="assets/images/login-backgroud.svg" alt="background image" class="img-bg" />
    </div>
  </div>
</div>
